import Utility from './Utility'
import Snap from 'snapsvg-cjs'

const CommonSymbols = {

    draw: (g, settings, svgs) => {
        let svgName = ''
        let scaleWidth = 0
        let scaleHeight = 0
        let xpos = 0
        let ypos = 0
        let opacity = ''
        let rotation = 0
        let svgKey = ''
        let derivedValues = {}

        settings.forEach(setting => {
            switch (setting.name) {
                case 'dimensions':
                    if (!setting.value || Array.isArray(setting.value) === false) {
                        derivedValues.width = 55
                        derivedValues.height = 55
                    }
                    else {
                        derivedValues.width = Utility.roundFloat(setting.value[0], 1)
                        derivedValues.height = Utility.roundFloat(setting.value[1], 1)
                    }
                    break
                case 'xy position': 
                if (Array.isArray(setting.value) === false || setting.value.length !== 2) {
                    setting.value = [1, 1]
                }
                if (isNaN(setting.value[0]) ) {
                    setting.value[0] = 1
                }
                if (isNaN(setting.value[1]) ) {
                    setting.value[1] = 1
                }
                derivedValues.xpos = Utility.roundFloat(setting.value[0], 2)
                    derivedValues.ypos = Utility.roundFloat(setting.value[1], 2)
                    break
                case 'color': derivedValues.lineColor = setting.value
                    break
                case 'line thickness': derivedValues.lineThickness = Utility.roundFloat(setting.value / 10, 2)
                    break
                case 'background color': derivedValues.backgroundColor = setting.value
                    break
                case 'fill color': derivedValues.fillColor = JSON.parse(setting.value)
                    break
                case 'svgKey': derivedValues.svgKey = parseInt(setting.value)
                    break
                case 'opacity': derivedValues.opacity = Utility.roundFloat(setting.value / 100, 3)
                    break
                case 'rotation': derivedValues.rotation = Utility.roundFloat(setting.value, 2)
                    break
                case 'symbol gap': derivedValues.symbolGap = Utility.roundFloat(setting.value, 2)
                    break
                default: console.warn('we seem to have missed one: ', setting.name)
            }
        })
        scaleWidth = derivedValues.width
        scaleHeight = derivedValues.height
        xpos = derivedValues.xpos
        ypos = derivedValues.ypos
        rotation = derivedValues.rotation
        svgKey = derivedValues.svgKey
        let svgObj = svgs.find(svg => svg.svgKey === svgKey)
        if (!svgObj) {
            console.warn('no svgObj aborting')
            return
        }
        svgName = svgObj.svgName.replace('common symbols ', '')
        svgName = svgObj.svgName.replace('common symbol ', '')
        opacity = derivedValues.opacity

        let fillColorObj = derivedValues.fillColor
        let fillInfo = ''
        if (fillColorObj.fillType === 'solid') {
            fillInfo = fillColorObj.fillColor
        }
        else { // gradient
            let type = derivedValues.fillColor.gradientDirection === 'radial' ? 'r' : 'l'
            let pxStart = derivedValues.fillColor.xyPositionStart.split(',')[0]
            let pyStart = derivedValues.fillColor.xyPositionStart.split(',')[1]
            let pxEnd = derivedValues.fillColor.xyPositionEnd.split(',')[0]
            let pyEnd = derivedValues.fillColor.xyPositionEnd.split(',')[1]
            let color1 = derivedValues.fillColor.colorStart
            let color2 = derivedValues.fillColor.colorMid
            let color3 = derivedValues.fillColor.colorEnd
            let defg = `${type}(${pxStart}, ${pyStart}, ${pxEnd}, ${pyEnd})${color1}-${color2}-${color3}`
            let parent = g.parent()
            var cg = parent.gradient(defg);
            fillInfo = cg
            //  var cg = parent.gradient("r(0.5, 0.5, 0.5, 1)#d00000-#e44-#ee0");
            //                             r(0,   0,   0.5, 1)#70e095-#6a1717-#FFFFFF

        }

        if (svgName === 'star') {
            let d = "M 0 -46.7 L 12.2 -11.9 50.3 -11.9 20.7 11 31.5 46.8 0 25.8 -31.4 46.8 -20.7 11 -50.3 -11.9 -12.2 -11.9 z"
            // scaleWidth *= 2
            // scaleHeight *= 2
            d = Utility.scaleDPath(d, scaleWidth / 100, scaleHeight / 100)
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
        }

        if (svgName === 'explode1') {
            let d = "M -77.87 -62.11 L -12.04 -29.61 L -6.62 -101.27 L 7.96 -29.19 L 45.43 -81.47 L 27.19 -26.05 L 55.99 -43.22 L 30.41 -12.77 L 86.71 -34.19 L 37.88 -3.42 L 63.38 12.06 L 35.57 16.95 L 57.54 61.22 L 22.86 31.8 L 25.88 67.89 L 7.1 34.5 L -7.87 98.72 L -12.87 30.81 L -65.37 66.64 L -23.75 19.26 L -91.14 21.42 L -25.38 1.62 L -77.3 -18.49 L -22.46 -16.28 z"

            d = Utility.scaleDPath(d, scaleWidth / 200, scaleHeight / 200)
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
        }

        if (svgName === 'explode2') {
            let d = "M -49.33 -87 L -0.49 -38.17 L 47.32 -98.58 L 32.49 -30.57 L 96.18 -42.61 L 37.39 -0.26 L 81.88 60.49 L 20.6 35.51 L 4.44 101.43 L -14.8 35.82 L -83.86 76.76 L -37.99 11.13 L -97.97 -24.01 L -33.05 -21.4 z"

            d = Utility.scaleDPath(d, scaleWidth / 200, scaleHeight / 200)
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
        }

        if (svgName === 'explode3') {
            //     <defs>
            //     <linearGradient id="MyGradient">
            //       <stop offset="5%" stop-color="#F60" />
            //       <stop offset="95%" stop-color="#FF6" />
            //     </linearGradient>
            //   </defs>
            let d = "M -60.29 -85.1 L -19.64 -9.77 L -9.02 -65.11 L 2.86 -12.38 L 43.09 -100.51 L 22.58 -8.14 L 47.41 -33.65 L 35.3 2.37 L 86.14 -51.21 L 60.98 9.69 L 83.01 -7.38 L 68.3 20.44 L 99.89 -2.86 L 73.53 39 L -72.46 39 L -100.11 -27.88 L -53.39 7.6 L -67.29 -24.59 L -42.91 -2.98 z"

            d = Utility.scaleDPath(d, scaleWidth / 200, scaleHeight / 200)
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)

        }

        if (svgName === 'fist') {

            let d1 = "m 778.82 39.92 c 0.66 -0.33 0.99 -0.78 1.15 0.49 c 0.16 1.27 -1.45 11.11 -2.05 12.21 c -0.36 0.66 -1.87 8.84 -2.75 10.72 c -0.88 1.88 -1.28 1.34 -3.09 3.75 c 0 0 -1.49 2.82 -2.39 3.72 c -0.9 0.9 -1.66 1.83 -1.8 2.34 c -0.14 0.51 -1.08 11.62 -0.7 14.62 c 0 3.17 0.06 11.04 -0.2 12.16 c -0.26 1.12 -0.51 2.61 -0.51 3.87 c 0 0 0.15 1.08 -0.63 1.15 c -0.78 0.07 -40.41 0.21 -40.41 0.21 c 0 0 -1.54 0 -0.06 -10.69 c 1.48 -10.69 2.3 -14.47 3.81 -23.18 c 0.57 -1.3 -5.51 -7.43 -10.39 -15.93 c -4.97 -8.67 -15.2 -19.36 -15.2 -22.59 c 0 -3.23 14.55 -28.88 19.16 -28.17 c 3.91 0.6 26.78 10.38 27.15 11.64 c 0.37 1.27 -0.14 7.39 -2.31 8.4 c -2.17 1.01 -8.77 3.59 -12.45 2.79 c 0 0 -5.36 -5.83 -7.28 -6.73 c 0 0 -0.51 0.35 0.12 1.92 c 0.62 1.58 -0.84 5.59 -3.16 7.21 c 0 0 -1.76 0.25 -1.62 0.55 c 0.14 0.29 0.42 0.7 2.43 0.97 c 2.02 0.27 3.34 1.36 4.12 1.75 c 0.78 0.39 3.58 0.97 5.18 1.91 c 1.6 0.94 18.82 26.39 18.8 27.61 c -0.02 1.22 -5.5 5.28 -7.91 5.51 c 0 0 -0.4 0 0 0.4 c 0.4 0.4 5.2 -0.08 5.71 0.43 c 0.51 0.51 0.16 1.83 0.53 3.06 c 0.37 1.23 1.81 10.58 1.49 12.09 c 0 0 -0.17 1.27 0.32 2.29 c 0.22 1.24 0.57 6.62 0.43 7.09 c -0.14 0.47 0.31 0.92 0.31 0.92 c 0 0 0.49 -0.23 0.49 -1.14 c 0 -0.91 -1.19 -21.03 -0.32 -21.81 c 0 0 0.81 -1.04 1.52 -1.04 c 0.71 0 1.99 -1.29 2.59 -1.61 c 0 0 0.33 -0.41 -0.56 -0.88 c -0.9 -0.47 -2.56 -1.51 -3.33 -4.81 c -0.94 -1.61 -1.96 -5.32 -3.41 -8.69 c -1.45 -3.37 -1.11 -2.93 -1.11 -2.93 c 0 0 -7.68 -9.23 -10.04 -12.33 c 0 0 -1.3 -1.71 0 -1.64 c 1.3 0.07 11.42 2.21 12.92 2.8 c 1.49 0.59 4.27 0.38 6.54 3.2 c 2.64 2.34 4.62 4.54 5.51 4.87 c 0 0 0.71 0.48 1 1.15 c 0.28 0.67 0.81 0.69 1.11 0.28"
            let d2 = "m 785.97 28.15 l -5.25 -5.38 c -0.83 -0.86 -2.71 -2 -3.66 -1.08 l -15.49 18.54 c -0.96 0.92 -1.06 2.38 -0.22 3.25 l 4.22 4.37 c 0.83 0.86 2.3 0.81 3.25 -0.11 l 16.94 -16.35 c 0.96 -0.92 1.06 -2.38 0.22 -3.25 z"
            let d3 = "m 774.32 16.04 l -6.29 -6.22 c -1.63 -1.29 -4.03 -1.01 -5.32 0.62 l -14.39 20.58 c -1.29 1.63 -1.01 4.03 0.62 5.32 l 6.77 3.24 c 1.63 1.29 4.03 1.01 5.32 -0.62 l 13.9 -17.6 c 1.29 -1.63 1.01 -4.03 -0.62 -5.32 z"
            let d4 = "m 736.95 8.93 l -7.69 -3.3 c -0.81 -0.52 -2.82 -1.53 -3.07 -2.4 c -0.28 -1 1.73 -2.73 2.33 -3.67 l 5.98 -9.32 c 1.12 -1.75 3.48 -2.27 5.23 -1.14 l 6.49 4.16 c 0.97 0.62 2.17 1.43 2.31 2.5 c 0.11 0.86 -0.67 1.95 -1.17 2.73 l -5.98 9.32 c -1.12 1.75 -2.69 2.24 -4.44 1.12 z"
            let d5 = "m 754.51 -3.55 l 8.03 4.81 c 1.79 1.07 2.37 3.41 1.3 5.19 l -5.59 9.33 c -0.47 0.78 -1.07 1.26 -1.6 1.92 c -0.23 0.28 -0.91 0.82 -1.51 1.71 c -1.4 2.07 -3.57 4.91 -4.27 4.49 c -1.39 -2.14 0.56 -5.83 0.49 -7.84 c -0.07 -1.77 -5 -3.11 -6.33 -3.79 c -0.84 -0.5 -2.66 -0.83 -2.92 -1.71 c -0.3 -0.99 1.05 -2.54 1.62 -3.49 l 5.59 -9.33 c 1.07 -1.79 3.41 -2.37 5.19 -1.3 z"
            let d6 = "m 749.18 26.1 c 0 0 0.39 0.01 0.03 0.73 c -0.46 0.69 -5.68 6.54 -6.27 7.42 c -0.59 0.89 -0.92 1.13 -1.31 1 c -3.17 -1.11 -9.17 -5.14 -10.05 -6.16 c -0.44 -0.51 -0.9 -2.13 0.97 -2.5 c 1.14 -0.06 1.15 0.36 2.05 1.87 c 0.91 1.51 4.09 0.52 5.58 0.12"

            let fistGroup = g.group()
            CommonSymbols.drawPath(fistGroup, d1, derivedValues, fillInfo)
            CommonSymbols.drawPath(fistGroup, d2, derivedValues, fillInfo)
            CommonSymbols.drawPath(fistGroup, d3, derivedValues, fillInfo)
            CommonSymbols.drawPath(fistGroup, d4, derivedValues, fillInfo)
            CommonSymbols.drawPath(fistGroup, d5, derivedValues, fillInfo)
            CommonSymbols.drawPath(fistGroup, d6, derivedValues, fillInfo)
            let tstring = 't -745 -45'
            fistGroup.transform(tstring)
            CommonSymbols.applyScale(fistGroup, scaleWidth / 100, scaleHeight / 100)
        }

        if (svgName === 'halt') {
            let d = "m -44.32 1.14 l -0.26 0.27 l -2.08 -0.83 v -30.65 c 0 -1.42 0.42 -2.76 1.14 -3.89 v 0 c 0.14 -0.22 0.29 -0.44 0.46 -0.64 c 0.17 -0.22 0.35 -0.42 0.53 -0.6 l 0.02 -0.02 c 0.54 -0.54 1.18 -1.01 1.89 -1.36 l 0.03 -0.01 l 0.35 -0.17 l 0.04 -0.02 c 0.86 -0.37 1.82 -0.58 2.81 -0.58 v 0 h 0.04 v 0 c 2.01 0 3.84 0.82 5.15 2.14 c 0.54 0.54 1.01 1.18 1.36 1.88 l 0.02 0.04 l 0.16 0.35 l 0.01 0.03 c 0.37 0.86 0.58 1.82 0.58 2.81 v 0.01 v 0.04 v 24.93 v 1.13 l -1.13 0.07 c -3.08 0.19 -5.91 1.18 -8.31 2.77 c -0.48 0.32 -0.94 0.66 -1.38 1.02 c -0.41 0.34 -0.84 0.72 -1.26 1.15 z m 63.2 20.8 l 1.23 0.46 l 0.53 0.39 c 0.09 0.12 0.2 0.22 0.33 0.31 v 0 l 0.16 0.09 v 0.01 c 0.17 0.08 0.35 0.12 0.54 0.12 v 0 h 0.03 c 0.18 0 0.34 -0.03 0.49 -0.09 l 0.12 -0.06 l 0.12 -0.07 l 0.04 -0.02 l 0.04 -0.02 c 0.54 -0.31 1.26 -0.85 2.05 -1.5 c 0.8 -0.67 1.71 -1.49 2.61 -2.33 c 1.76 -1.66 3.76 -3.66 4.55 -4.44 l 0.04 -0.04 c 2.53 -2.53 5.1 -3.7 7.37 -3.85 c 0.46 -0.03 0.92 -0.02 1.35 0.03 c 0.44 0.05 0.87 0.14 1.28 0.27 h 0.01 l 0.05 0.02 h 0.01 c 0.81 0.26 1.56 0.67 2.22 1.2 l 0.03 0.03 l 0.31 0.27 l 0.06 0.05 l 0.29 0.29 l 0.05 0.06 l 0.01 0.01 v 0 l 0.01 0.02 v 0 c 0.56 0.62 1.01 1.35 1.34 2.16 l 0.02 0.03 l 0.15 0.42 l 0.02 0.09 l 0.12 0.43 l 0.01 0.05 l 0.01 0.06 v 0 c 0.57 2.38 0.1 5.26 -1.88 8.16 c -0.37 0.55 -0.81 1.11 -1.29 1.65 c -0.48 0.54 -1.02 1.09 -1.62 1.62 v 0 l -0.08 0.07 l -0.1 0.09 l -0.07 0.07 l -0.04 0.04 l -24.49 24.77 l -0.85 0.93 l -0.06 -0.06 c -1.35 1.23 -2.67 2.29 -4 3.2 c -1.6 1.08 -3.22 1.95 -4.89 2.61 c -1.69 0.67 -3.46 1.15 -5.32 1.46 c -1.87 0.3 -3.84 0.45 -5.93 0.45 h -15.88 c -5.29 0 -10.22 -1.56 -14.34 -4.22 v 0 c -0.79 -0.51 -1.57 -1.08 -2.32 -1.69 c -0.76 -0.62 -1.47 -1.26 -2.12 -1.92 l -0.02 -0.02 v 0 c -2.01 -2.04 -3.71 -4.41 -4.99 -7.02 c -0.25 -0.52 -0.49 -1.04 -0.71 -1.56 c -1.36 -3.24 -2.11 -6.78 -2.12 -10.5 v 0 v -0.03 v -20.94 c 0 -1.93 0.36 -3.79 1 -5.48 v -0.01 c 0.12 -0.31 0.26 -0.64 0.41 -0.97 v 0 c 0.15 -0.32 0.31 -0.64 0.48 -0.95 l 0.01 -0.02 l 0.03 -0.05 l 0.02 -0.04 c 0.62 -0.97 1.36 -1.88 2.19 -2.69 l 0.02 -0.02 l 0.46 -0.43 l 0.04 -0.03 l 0.48 -0.41 l 0.04 -0.04 l 0.02 -0.02 v 0 c 1.06 -0.85 2.24 -1.57 3.51 -2.11 v 0 c 0.29 -0.12 0.57 -0.24 0.76 -0.3 v 0 c 1.56 -0.57 3.25 -0.88 5 -0.88 v 0 h 0.04 h 0.64 l 0.29 0.04 l 0.27 0.07 l 0.21 0.02 v 0 h 17.25 v 0 h 0.11 h 0.08 h 0.11 v 0 h 17.25 v 0 h 0.05 h 0.07 h 0.05 v 0 h 1.28 c 2.54 0 4.93 0.65 7.04 1.79 v 0 c 0.42 0.23 0.82 0.47 1.19 0.72 v 0 h 0.01 c 0.36 0.24 0.74 0.52 1.11 0.82 l 0.01 0.01 l 0.02 0.02 v 0 c 1.82 1.49 3.3 3.41 4.24 5.59 c 0.2 0.45 0.37 0.89 0.5 1.31 v 0 c 0.15 0.45 0.27 0.91 0.38 1.37 v 0.01 l 0.01 0.07 l 0.02 0.11 c 0.01 0.08 0.02 0.16 0.04 0.22 v 0 l 0.01 0.03 v 0 l 0.04 0.11 v 0 l 0.02 0.06 l 0.12 0.36 l 0.06 0.65 v 0.04 l 0.02 0.26 v 0.04 l 0.02 0.46 v 0.03 v 0.25 v 0.01 v 4.42 v 1.66 l -1.58 -0.52 c -2.46 -0.81 -4.8 -1.36 -7.02 -1.66 v 0 c -0.5 -0.07 -0.98 -0.12 -1.42 -0.17 c -0.45 -0.04 -0.92 -0.08 -1.39 -0.1 l -1.02 -0.03 c -2.85 -0.04 -5.47 0.37 -7.8 1.17 c -0.51 0.18 -0.99 0.36 -1.42 0.55 c -0.45 0.2 -0.9 0.41 -1.32 0.64 l -0.71 0.41 c -2.23 1.34 -4.07 3.14 -5.48 5.33 c -0.29 0.46 -0.56 0.9 -0.78 1.33 c -0.24 0.45 -0.46 0.94 -0.68 1.44 v 0 l -0.01 0.03 v 0 c -0.68 1.62 -1.17 3.4 -1.45 5.32 c -0.06 0.44 -0.12 0.87 -0.15 1.28 c -0.03 0.34 -0.07 0.7 -0.08 1.06 l 2.66 0.03 c 0.08 -1.35 0.28 -2.64 0.57 -3.84 v 0 c 0.09 -0.37 0.18 -0.72 0.27 -1.03 v 0 c 0.09 -0.3 0.2 -0.64 0.33 -0.98 v 0 l 0.32 -0.82 v 0 c 0.89 -2.13 2.18 -3.93 3.8 -5.37 c 0.32 -0.28 0.66 -0.55 0.99 -0.8 c 0.37 -0.27 0.72 -0.51 1.06 -0.71 l 0.02 -0.01 l 0.03 -0.02 v 0 c 1.7 -1.02 3.68 -1.73 5.89 -2.09 c 0.45 -0.07 0.94 -0.14 1.44 -0.18 c 0.49 -0.05 1 -0.07 1.49 -0.09 h 0.03 h 0.98 h 0.02 c 2.3 0.03 4.78 0.39 7.43 1.07 v 0 c 0.61 0.15 1.18 0.32 1.72 0.49 c 0.62 0.19 1.21 0.39 1.77 0.58 z m -49.82 -22.73 z m 32.46 -3.19 h -12.17 h -1.2 v -1.2 v -48.84 v 0 c 0 -2.01 0.82 -3.84 2.14 -5.15 c 0.54 -0.54 1.18 -1.01 1.88 -1.36 l 0.03 -0.01 l 0.35 -0.17 l 0.04 -0.02 c 0.86 -0.37 1.81 -0.58 2.81 -0.58 v -0.01 h 0.04 v 0.01 c 2.01 0 3.84 0.82 5.15 2.14 c 0.54 0.54 1 1.18 1.36 1.88 l 0.02 0.03 l 0.16 0.35 l 0.02 0.04 c 0.37 0.86 0.58 1.81 0.58 2.81 v 0.01 v 0.04 v 48.83 v 1.2 h -1.2 z m 5.38 0.05 l -0.22 -0.02 l -1.12 -0.09 v -1.11 v -37.17 v 0 c 0 -2.01 0.82 -3.84 2.14 -5.15 c 0.54 -0.54 1.18 -1 1.89 -1.36 l 0.04 -0.02 l 0.35 -0.16 l 0.03 -0.02 c 0.86 -0.37 1.81 -0.58 2.81 -0.58 v 0 h 0.04 c 1.42 0 2.76 0.42 3.89 1.14 v 0 l 0.01 0.01 c 0.22 0.13 0.43 0.29 0.63 0.45 v 0 l 0.01 0.01 c 0.21 0.16 0.41 0.34 0.59 0.52 l 0.02 0.02 c 0.54 0.54 1.01 1.18 1.36 1.88 l 0.01 0.03 l 0.17 0.35 l 0.02 0.04 c 0.37 0.86 0.58 1.82 0.58 2.81 v 0 v 0.04 v 42.85 l -2.07 0.84 l -0.2 -0.2 c -2.06 -2.06 -4.62 -3.62 -7.48 -4.44 c -0.57 -0.17 -1.16 -0.31 -1.73 -0.41 c -0.55 -0.11 -1.15 -0.19 -1.76 -0.24 z m -22.92 -0.05 h -12.17 h -1.21 v -1.2 v -24.9 v 0 v -12.36 v 0 c 0 -1.42 0.42 -2.77 1.14 -3.9 v 0 c 0.14 -0.23 0.3 -0.45 0.46 -0.65 c 0.17 -0.22 0.35 -0.42 0.52 -0.59 l 0.02 -0.02 c 0.54 -0.54 1.18 -1 1.89 -1.36 l 0.03 -0.01 l 0.35 -0.16 l 0.04 -0.02 c 0.86 -0.37 1.81 -0.58 2.81 -0.58 v 0 h 0.04 v 0 c 2.01 0 3.84 0.82 5.15 2.14 c 0.54 0.54 1 1.18 1.36 1.88 l 0.01 0.03 l 0.17 0.35 l 0.02 0.04 c 0.37 0.86 0.58 1.82 0.58 2.81 v 0 v 0.04 v 37.25 v 1.2 h -1.2 z"
            //   d = Utility.roundFloatsInString(d, 2)
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
            CommonSymbols.applyScale(g, scaleWidth / 100, scaleHeight / 100)
        }

        if (svgName === 'supply circle') {
            let x1 = 0
            let y1 = 0
            let r = 50
            let x2 = 0
            let y2 = -50 - derivedValues.lineThickness / 2
            let w = 50 + derivedValues.lineThickness
            let h = 100 + derivedValues.lineThickness
            y2 = Utility.roundFloat(y2, 2)
            w = Utility.roundFloat(w, 2)
            h = Utility.roundFloat(h, 2)

            let rightHalf = g.circle(x1, y1, r).attr({
                stroke: derivedValues.lineColor,
                strokeWidth: derivedValues.lineThickness,
                fill: "white"
            })
            let maskRect1 = g.rect(x2, y2, w, h).attr({ stroke: "none", fill: "white" })
            rightHalf.attr({ mask: maskRect1 })


            x2 = -50 - derivedValues.lineThickness / 2
            y2 = -50 - derivedValues.lineThickness / 2
            w = 50 + derivedValues.lineThickness
            h = 100 + derivedValues.lineThickness

            x2 = Utility.roundFloat(x2, 2)
            y2 = Utility.roundFloat(y2, 2)
            w = Utility.roundFloat(w, 2)
            h = Utility.roundFloat(h, 2)

            let leftHalf = g.circle(x1, y1, r).attr({
                stroke: derivedValues.lineColor,
                strokeWidth: derivedValues.lineThickness,
                fill: "black"
            })
            let maskRect2 = g.rect(x2, y2, w, h).attr({ stroke: "none", fill: "white" })
            leftHalf.attr({ mask: maskRect2 })
            CommonSymbols.applyScale(g, scaleWidth / 100, scaleHeight / 100)
        }
        if (svgName === 'supply barrel') {
            let d = "m -19.28 -48.51 c 4.42 0 8 1.61 8 3.6 c 0 1.99 -3.58 3.6 -8 3.6 c -4.42 0 -8 -1.61 -8 -3.6 c 0 -1.99 3.58 -3.6 8 -3.6 z m 19.33 -12.72 c 10.66 0 20.36 1.64 27.42 4.29 c 7.66 2.87 12.39 7.04 12.39 11.81 c 0 1.71 -0.61 3.34 -1.74 4.86 v 24.66 c -0.9 0.95 -1.97 1.83 -3.2 2.64 c -8.29 5.47 -23.18 7.6 -37.53 7.16 c -14.31 -0.44 -27.97 -3.42 -33.84 -8.18 c -0.54 -0.44 -1.01 -0.88 -1.39 -1.34 l 0.12 -0.13 v -24.41 c -1.33 -1.63 -2.05 -3.4 -2.05 -5.26 c 0 -4.78 4.74 -8.94 12.39 -11.81 c 7.07 -2.65 16.77 -4.29 27.43 -4.29 z m 39.59 48.17 c 0.45 0.94 0.68 1.91 0.68 2.91 c 0 1.8 -0.77 3.54 -2.19 5.15 v 20.51 c -0.9 0.95 -1.97 1.83 -3.2 2.64 c -8.29 5.47 -23.18 7.6 -37.53 7.16 c -14.32 -0.44 -27.98 -3.42 -33.85 -8.18 c -0.57 -0.46 -1.05 -0.93 -1.44 -1.4 l 0.17 -0.2 v -20.39 c -1.51 -1.66 -2.33 -3.44 -2.33 -5.3 c 0 -0.92 0.2 -1.82 0.59 -2.7 c 0.37 0.38 0.77 0.74 1.2 1.09 c 6.36 5.15 20.69 8.36 35.58 8.82 c 14.86 0.46 30.38 -1.82 39.19 -7.63 c 1.16 -0.76 2.2 -1.59 3.13 -2.48 z m 0.04 31.07 c 0.42 0.91 0.64 1.86 0.64 2.82 c 0 1.8 -0.77 3.54 -2.19 5.15 v 15.79 c 1.19 1.45 1.83 2.99 1.83 4.59 c 0 8.44 -17.83 15.29 -39.82 15.29 c -21.99 0 -39.82 -6.84 -39.82 -15.29 c 0 -1.66 0.69 -3.25 1.96 -4.74 v -15.49 c -1.51 -1.66 -2.33 -3.44 -2.33 -5.3 c 0 -0.89 0.19 -1.76 0.55 -2.61 c 0.38 0.39 0.79 0.77 1.24 1.13 c 6.36 5.15 20.69 8.36 35.58 8.82 c 14.86 0.46 30.38 -1.82 39.19 -7.63 c 1.17 -0.78 2.24 -1.62 3.17 -2.53 z m -13.97 -71.23 c -6.52 -2.45 -15.59 -3.96 -25.66 -3.96 c -10.07 0 -19.14 1.51 -25.66 3.96 c -5.93 2.22 -9.6 5.1 -9.6 8.09 c 0 3 3.67 5.87 9.6 8.09 c 6.52 2.44 15.59 3.96 25.66 3.96 c 10.07 0 19.14 -1.51 25.66 -3.96 c 5.93 -2.22 9.6 -5.1 9.6 -8.09 c 0 -2.99 -3.67 -5.87 -9.6 -8.09 z m -44.99 6.61 c 2.69 0 4.87 0.76 4.87 1.7 c 0 0.94 -2.18 1.7 -4.87 1.7 c -2.69 0 -4.87 -0.76 -4.87 -1.7 c 0 -0.93 2.18 -1.7 4.87 -1.7 z"
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
            CommonSymbols.applyScale(g, scaleWidth / 100, scaleHeight / 100)
        }

        if (svgName === 'diamond') {
            let x1 = 0
            let y1 = -50

            let x2 = 44
            let y2 = 0

            let x3 = 0
            let y3 = 50
            let x4 = -44
            let y4 = 0
            let d = `M ${x1} ${y1} ${x2} ${y2} ${x3} ${y3} ${x4} ${y4} z`
            CommonSymbols.drawPath(g, d, derivedValues, fillInfo)
            CommonSymbols.applyScale(g, scaleWidth / 100, scaleHeight / 100)
        }

        if (svgName === 'caution') {
            let d1 = "m -52.33 33.4 l 43.12 -74.59 c 5.24 -8.25 13.54 -8.46 18.87 0 l 42.43 73.69 c 3.39 6.81 1.71 16 -9.33 15.77 h -86.48 c -7.26 0.18 -11.94 -6.19 -8.61 -14.87 z"
            // exclamation mark
            let d2 = "m -3.76 27.34 a 5.48 5.48 0 0 1 3.43 -1.58 a 5.66 5.66 0 0 1 4.42 1.66 a 5.53 5.53 0 0 1 1.62 3.54 a 5.6 5.6 0 0 1 -0.04 1.41 a 6 6 0 0 1 -0.42 1.34 a 5.53 5.53 0 0 1 -2.92 2.84 a 5.79 5.79 0 0 1 -4.57 -0.1 a 5.51 5.51 0 0 1 -2.81 -2.94 a 5.31 5.31 0 0 1 -0.36 -1.27 a 5.9 5.9 0 0 1 -0.06 -1.32 v 0 a 6.45 6.45 0 0 1 0.57 -2 a 4.6 4.6 0 0 1 1.14 -1.56 z m 8.15 -10.24 c -0.19 4.79 -8.31 4.8 -8.49 0 c -0.82 -8.21 -2.92 -27.7 -2.86 -35.42 c 0.07 -2.38 2 -3.78 4.56 -4.32 a 11.19 11.19 0 0 1 2.49 -0.24 a 11.77 11.77 0 0 1 2.5 0.25 c 2.61 0.55 4.65 2 4.65 4.44 v 0.24 z"
            let derivedCopy = { ...derivedValues }
            CommonSymbols.drawPath(g, d1, derivedValues, fillInfo)
            derivedCopy.lineColor = "none"
            CommonSymbols.drawPath(g, d2, derivedCopy, "black")
            CommonSymbols.applyScale(g, scaleWidth / 100, scaleHeight / 100)
        }

        if (opacity < 1) {
            g.attr({ "opacity": opacity })
        }

        if (rotation > 0) {
            CommonSymbols.applyRotation(g, rotation)
        }
        if (xpos !== 0 || ypos !== 0) {
            CommonSymbols.applyTranslation(g, xpos, ypos)
        }

    },

    drawPath: (g, d, derivedValues, fillInfo) => {
        // let parent = g.parent()
        // // x y position for center, color stop middle (i guess)
        // // the start, mid, and end gradient colors.

        // //g.attr({fill: cg})
        // let fillColorObj = derivedValues.fillColor
        // let fillInfo = ''
        // if (fillColorObj.fillType === 'solid') {
        //     fillInfo = fillColorObj.fillColor
        // }
        // else { // gradient
        //     let type = derivedValues.fillColor.gradientDirection === 'radial' ? 'r' : 'l'
        //     let pxStart = derivedValues.fillColor.xyPositionStart.split(',')[0]
        //     let pyStart = derivedValues.fillColor.xyPositionStart.split(',')[1]
        //     let pxEnd = derivedValues.fillColor.xyPositionEnd.split(',')[0]
        //     let pyEnd = derivedValues.fillColor.xyPositionEnd.split(',')[1]
        //     let color1 = derivedValues.fillColor.colorStart
        //     let color2 = derivedValues.fillColor.colorMid
        //     let color3 = derivedValues.fillColor.colorEnd
        //     let defg = `${type}(${pxStart}, ${pyStart}, ${pxEnd}, ${pyEnd})${color1}-${color2}-${color3}`
        //     let parent = g.parent()
        //     var cg = parent.gradient(defg);
        //     fillInfo = cg
        //     //  var cg = parent.gradient("r(0.5, 0.5, 0.5, 1)#d00000-#e44-#ee0");
        //     //                             r(0,   0,   0.5, 1)#70e095-#6a1717-#FFFFFF

        // }
        g.path(d).attr({
            "strokeLinecap": "round",
            stroke: derivedValues.lineColor,
            strokeWidth: derivedValues.lineThickness,
            fill: fillInfo,
            strokeLinejoin: "round"
        });
    },

    drawLine: (g, x1, y1, x2, y2, derivedValues) => {
        x1 = Utility.roundFloat(x1, 2)
        y1 = Utility.roundFloat(y1, 2)
        x2 = Utility.roundFloat(x2, 2)
        y2 = Utility.roundFloat(y2, 2)
        g.line(Utility.roundFloat(x1, 2), Utility.roundFloat(y1), Utility.roundFloat(x2), Utility.roundFloat(y2)).attr({
            "stroke": derivedValues.lineColor,
            "strokeWidth": derivedValues.lineThickness,
            "strokeLinejoin": "round"
        })
    },

    drawBlankEllipse: (g, x, y, rx, ry, derivedValues) => {
        x = Utility.roundFloat(x, 2)
        y = Utility.roundFloat(y, 2)
        rx = Utility.roundFloat(rx, 2)
        ry = Utility.roundFloat(ry, 2)
        g.ellipse(Utility.roundFloat(x, 2), Utility.roundFloat(y, 2), Utility.roundFloat(rx, 2), Utility.roundFloat(ry, 2)).attr({
            "stroke": derivedValues.lineColor,
            "strokeWidth": derivedValues.lineThickness,
            "fill": "none"
        })
    },

    drawEllipse: (g, x, y, rx, ry, derivedValues) => {
        x = Utility.roundFloat(x, 2)
        y = Utility.roundFloat(y, 2)
        rx = Utility.roundFloat(rx, 2)
        ry = Utility.roundFloat(ry, 2)
        g.ellipse(Utility.roundFloat(x, 2), Utility.roundFloat(y, 2), Utility.roundFloat(rx, 2), Utility.roundFloat(ry, 2)).attr({
            "stroke": derivedValues.lineColor,
            "strokeWidth": derivedValues.lineThickness,
            "fill": "none"
        })
    },

    drawTriangle: (g, tx1, ty1, tx2, ty2, tx3, ty3, derivedValues) => {
        tx1 = Utility.roundFloat(tx1, 2)
        ty1 = Utility.roundFloat(ty1, 2)
        tx2 = Utility.roundFloat(tx2, 2)
        ty2 = Utility.roundFloat(ty2, 2)
        tx3 = Utility.roundFloat(tx3, 2)
        ty3 = Utility.roundFloat(ty3, 2)
        g.path(`M ${tx1} ${ty1} ${tx2} ${ty2} ${tx3} ${ty3} z`).attr({
            "stroke": "none",
            "strokeWidth": 0,
            "fill": derivedValues.lineColor,
        })
    },

    drawCircle: (g, x, y, r, derivedValues) => {
        x = Utility.roundFloat(x, 2)
        y = Utility.roundFloat(y, 2)
        r = Utility.roundFloat(r, 2)
        g.circle(x, y, r).attr({
            "stroke": "none",
            "fill": derivedValues.lineColor
        })
    },

    drawBlankCircle: (g, x, y, r, derivedValues) => {
        x = Utility.roundFloat(x, 2)
        y = Utility.roundFloat(y, 2)
        r = Utility.roundFloat(r, 2)
        g.circle(x, y, r).attr({
            "stroke": derivedValues.lineColor,
            "strokeWidth": derivedValues.lineThickness,
            "fill": "none"
        })
    },

    applyRotation: (g, rotation) => {
        let measureG = g.getBBox()
        let currentMatrix = g.transform().localMatrix;
        let addMatrix = new Snap.Matrix()
        addMatrix.rotate(rotation, measureG.cx, measureG.cy)
        addMatrix.add(currentMatrix)
        g.transform(addMatrix)
    },

    applyTranslation: (g, xpos, ypos) => {
        let currentMatrix = g.transform().localMatrix;
        let addMatrix = new Snap.Matrix()
        addMatrix.translate(xpos, ypos)
        addMatrix.add(currentMatrix)
        g.transform(addMatrix)
    },

    applyScale: (g, scaleWidth, scaleHeight) => {
        let currentMatrix = g.transform().localMatrix;
        let addMatrix = new Snap.Matrix()
        addMatrix.scale(scaleWidth, scaleHeight)
        addMatrix.add(currentMatrix)
        g.transform(addMatrix)
    },

}
export default CommonSymbols